var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productList.length === 0)?_c('contents-none',{attrs:{"none-text":"검색 결과가 없습니다."}}):_c('products-list',{attrs:{"listTypeBest":true,"isCartbuttonVisible":false,"productList":_vm.productList}})}
var staticRenderFns = []

export { render, staticRenderFns }